export const PADDOCK_PASS_REQUIRED_MESSAGE = 'Paddock Pass is required to create or import racing lines, starting with your first line.'

export const requireRacingLineEntitlement = ({ auth, onAllowed, onDenied }) => {
  const deny = (reason = 'no_entitlement') => {
    if (typeof onDenied === 'function') onDenied(reason)
  }

  if (!auth || !auth.user || auth.user.isAnonymous) {
    if (auth && typeof auth.requireAuth === 'function') auth.requireAuth(() => {})
    return Promise.resolve(false)
  }

  const functionsInstance = auth.app && auth.app.functions && auth.app.functions()
  if (!functionsInstance || typeof functionsInstance.httpsCallable !== 'function') {
    deny('service_unavailable')
    return Promise.resolve(false)
  }

  // Refresh first so a just-completed Stripe checkout can pick up the extension's
  // paddock_pass claim before the callable and Firestore rules evaluate it.
  return auth.user.getIdToken(true)
    .then(() => functionsInstance.httpsCallable('canCreateRacingLine')({}))
    .then(result => {
      if (!result?.data?.allowed) {
        deny(result?.data?.reason || 'no_entitlement')
        return false
      }
      if (typeof onAllowed === 'function') onAllowed(auth.user)
      return true
    })
    .catch(() => {
      deny('service_unavailable')
      return false
    })
}